import PropTypes from 'prop-types'
import useTranslations from '../../../i18n/useTranslations'

import {
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material'

const EnhancedTableHead = ({
  headCells,
  order,
  orderBy,
  onRequestSort,
  numSelected,
  showCheckbox,
  onSelectAllClick,
  rowCount,
  rows,
  selectedRows,
}) => {
  const t = useTranslations()
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  const isCheckboxActive = () => {
    const actualSelected = rows.filter(a =>
      selectedRows.some(e => a.data?.id === e?.id),
    )

    return actualSelected.length === rows.length
  }

  return (
    <TableHead>
      <TableRow>
        {showCheckbox ? (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={
                rows && selectedRows
                  ? isCheckboxActive()
                  : numSelected > 0 && numSelected < rowCount
              }
              checked={
                rows && selectedRows
                  ? isCheckboxActive()
                  : rowCount > 0 && numSelected === rowCount
              }
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all desserts' }}
            />
          </TableCell>
        ) : null}
        {headCells.map(headCell => {
          const label = t(`noun:${headCell.id}`)
          return (
            <TableCell
              key={headCell.id}
              className={headCell.extraClass}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.sortable ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                  style={
                    {
                      // color: orderBy === headCell.id ? '#DF0024' : '',
                    }
                  }
                >
                  {label}
                </TableSortLabel>
              ) : (
                label
              )}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  headCells: PropTypes.array.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
  rows: PropTypes.any,
  selectedRows: PropTypes.any,
  showCheckbox: PropTypes.bool
}

export default EnhancedTableHead
